export default {
    centrosCusto: [],
    centroCusto: {}
}